module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNDgwIiB3aWR0aD0iNjQwIiB2aWV3Qm94PSIwIDAgNjQwIDQ4MCI+CiAgPHBhdGggZmlsbD0iIzAwNmIzZiIgZD0iTTAgMGg2NDB2NDgwSDB6Ii8+CiAgPHBhdGggZmlsbD0iI2ZjZDExNiIgZD0iTTAgMGg2NDB2MzIwSDB6Ii8+CiAgPHBhdGggZmlsbD0iI2NlMTEyNiIgZD0iTTAgMGg2NDB2MTYwSDB6Ii8+CiAgPHBhdGggZD0iTTMyMCAxNjBsNTEuOTg3IDE2MC0xMzYuMTA0LTk4Ljg4NWgxNjguMjM0TDI2OC4wMTMgMzIweiIvPgo8L3N2Zz4K"


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/4x3/gh.svg
// module id = ./node_modules/flag-icon-css/flags/4x3/gh.svg
// module chunks = 0